// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import ClaimEventController from "./claim_event_controller"
application.register("claim-event", ClaimEventController)

import ConsentToggleController from "./consent_toggle_controller"
application.register("consent-toggle", ConsentToggleController)

import ContributionController from "./contribution_controller"
application.register("contribution", ContributionController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InstallPromptController from "./install_prompt_controller"
application.register("install-prompt", InstallPromptController)

import InvitationShareController from "./invitation_share_controller"
application.register("invitation-share", InvitationShareController)

import MobileActionBarController from "./mobile_action_bar_controller"
application.register("mobile-action-bar", MobileActionBarController)

import RootTypeController from "./root_type_controller"
application.register("root-type", RootTypeController)

import SearchAutocompleteController from "./search_autocomplete_controller"
application.register("search-autocomplete", SearchAutocompleteController)

import SelectSearchController from "./select_search_controller"
application.register("select-search", SelectSearchController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TreeDragController from "./tree_drag_controller"
application.register("tree-drag", TreeDragController)

import TreeGraphController from "./tree_graph_controller"
application.register("tree-graph", TreeGraphController)

import TreeQuickAddController from "./tree_quick_add_controller"
application.register("tree-quick-add", TreeQuickAddController)

import TreeSearchController from "./tree_search_controller"
application.register("tree-search", TreeSearchController)

import UndoController from "./undo_controller"
application.register("undo", UndoController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
